import ContactUsHeroSection from './ContactUsHero';
import MainContactSection from './MainContactSection';
import FAQSection from './FAQ';
import MapSection from './Map';
import CTASection from './Cta';
import SEO from '../SEO';

const ContactUsPage = () => {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <SEO
        title="Contact Us | MetaFit Wellness"
        description="Get in touch with MetaFit Wellness. Contact our corporate office in Udaipur, call +91 8829912389, or email cto.metafit@gmail.com for inquiries and support."
        keywords="contact metafit, metafit customer support, wellness center Udaipur, metafit phone number, metafit email"
        url="https://www.metafitwellness.com/contact"
        canonical="https://www.metafitwellness.com/contact"
        image="https://www.metafitwellness.com/metafit.webp"
        schema={{
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Contact MetaFit Wellness",
          "url": "https://www.metafitwellness.com/contact",
          "mainEntity": {
            "@type": "LocalBusiness",
            "name": "MetaFit Wellness",
            "telephone": "+918829912389",
            "email": "cto.metafit@gmail.com",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "First Floor, Above Arbuda Electric, Behind Celebration Mall, Plot No. 5, Garh Magri, Ratneshwar Colony, Pulla Bhuwana",
              "addressLocality": "Udaipur",
              "addressRegion": "Rajasthan",
              "postalCode": "313001",
              "addressCountry": "IN"
            }
          }
        }}
      />
      {/* Hero Section */}
      <ContactUsHeroSection/>
      {/* Main Contact Section */}
      <MainContactSection/>
      {/* FAQ Section */}
      <FAQSection/>
      {/* Map Section */}
      <MapSection/>
      {/* CTA Section */}
      <CTASection/>
    </div>
  );
};

export default ContactUsPage;
